const handleLogout = () => {
  localStorage.clear();
  sessionStorage.clear();
  window.location.href = "/Login";
};

export default handleLogout;
